import {readTimelineAnimationWindow} from '../../protocol/animation-window';
import type {EditorStarterItem} from '../../vendor/src/features/remotion-editor/editor/items/item-type';

/** Capture the authored clip clock; moving the whole clip does not change this local clock. */
export function preserveBasicFadeWindows<T extends EditorStarterItem>(item:T,fps:number,offsetFrames=0,sourceDuration=item.durationInFrames,capturedOnly=false):T{
  let result=item;
  for(const kind of ['visual','audio'] as const){
    const key=kind==='visual'?'visualFadeWindow':'audioFadeWindow';
    const old=readTimelineAnimationWindow(item[key]);
    const fadeIn=kind==='visual'&&'fadeInDurationInSeconds' in item?item.fadeInDurationInSeconds:kind==='audio'&&'audioFadeInDurationInSeconds' in item?item.audioFadeInDurationInSeconds:0;
    const fadeOut=kind==='visual'&&'fadeOutDurationInSeconds' in item?item.fadeOutDurationInSeconds:kind==='audio'&&'audioFadeOutDurationInSeconds' in item?item.audioFadeOutDurationInSeconds:0;
    if(!old&&(capturedOnly||(!fadeIn&&!fadeOut)))continue;
    const window=readTimelineAnimationWindow({startInSeconds:(old?.startInSeconds??0)-offsetFrames/fps,endInSeconds:(old?.endInSeconds??sourceDuration/fps)-offsetFrames/fps});
    if(window)result={...result,[key]:window};
  }
  return result;
}
